export default __webpack_public_path__ + "static/media/miku.c18aeaa3.jpg";